import { useTranslation } from "react-i18next";
import "./FileInput.scss";

type FileInputProps = {
  label?: string;
  clickHereForLabel?: string;
  onChange: (files: File| FileList | null) => Promise<void>;
  containerWrapperClassName?: string;
  labelClassName?: string;
  disabled?: boolean;
  allowedFileTypes?: string;
  subTitle?: string;
  isMultiple?:boolean;
  readonly?:boolean;
};

const FileInput: React.FC<FileInputProps> = ({
  label,
  onChange,
  labelClassName,
  clickHereForLabel,
  containerWrapperClassName,
  disabled,
  allowedFileTypes = ".xls,.xlsx,.pdf,.doc,.docx,.zip,image/*",
  subTitle,
  isMultiple=false,
  readonly=false
    
}) => {
  const { t } = useTranslation("Common");
  const onLocalChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
        const fileList = Array.from(files);
      fileList.map(async (file) => await onChange(file));
    }
    // Reset the input value to allow selecting the same file again
    e.target.value = '';
  };

  return (
    <div className={`mb-3 file-input-container ${containerWrapperClassName}`}>
      {label && (
        <label htmlFor="formFile" className={`mb-1 ${labelClassName}`}>
          {label}
        </label>
      )}
      <div className="position-relative">
        <div className="file-drop-zone">
          <span>
            <strong className="text-primary px-2">{t("clickHere")}</strong>
            {clickHereForLabel}
            {subTitle && <p className="mb-0 mt-1 text-muted fs-12px">{subTitle}</p>}
          </span>
          <input
            accept={allowedFileTypes}
            className="file-input"
            type="file"
            multiple={isMultiple}
            onChange={onLocalChange}
            disabled={disabled}
            readOnly={readonly}
          />
        </div>
      </div>
    </div>
  );
};

export default FileInput;
